import * as React from 'react';

import { PDFReader as KSPDFReader } from '@uncinc/uncinc-react-kitchen-sink';
import { PDFReaderProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/PDFReader';

import './style.scss';

const PDFReader: React.FC<PDFReaderProps> = (props) => {
  return (
    <KSPDFReader
      {...props}
    />
  );
};

export default PDFReader;
